export default __webpack_public_path__ + "static/media/messenger.e2f753b2.png";